<div class="pd-content-container">
    <!-- Spinner while catalog is being loaded -->
    <div *ngIf="loading && !loadError" class="pd-loader">
        <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
    </div>

    <!-- Error loading content -->
    <div *ngIf="!loading && loadError" class="pd-permission-error">
        <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
        There was an error loading the product catalog. Click below try again.
        <button hc-button size="lg" (click)="loadCatalog()">Reload Catalog</button>
    </div>

    <div class="product-catalog-table-container" [hidden]="loadError || loading">
        <div class="product-catalog-control-bar">
            <div class="product-catalog-filters">
                <div class="filter-dropdown" title="Filter by category">
                    <label for="category">Category</label>
                    <button hc-button buttonStyle="link-inline" id="category" [hcPop]="filtermenu"
                        (click)="storeFilterData('category')" [context]="categoryFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ categoryText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <div class="filter-dropdown" title="Filter by product type">
                    <label for="type">Type</label>
                    <button hc-button buttonStyle="link-inline" id="type" [hcPop]="filtermenu"
                        (click)="storeFilterData('type')" [context]="typeFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ typeText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <div class="filter-dropdown" title="Filter by product line">
                    <label for="productLine">Product Line</label>
                    <button hc-button buttonStyle="link-inline" id="productLine" [hcPop]="filtermenu"
                        (click)="storeFilterData('productLine')" [context]="productLineFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ productLineText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <div class="filter-dropdown" title="Filter by status">
                    <label for="status">Status</label>
                    <button hc-button buttonStyle="link-inline" id="status" [hcPop]="filtermenu"
                        (click)="storeFilterData('status')" [context]="statusFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ statusText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <div class="filter-dropdown" title="Filter by publish status" *ngIf="oktaService.admin">
                    <label for="publishedStatus">Publish Status</label>
                    <button hc-button buttonStyle="link-inline" id="publishedStatus" [hcPop]="filtermenu"
                        (click)="storeFilterData('published')" [context]="publishStatusFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ publishStatusText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>

                <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                    <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                        (filterChecked)="storeFilterArray($event)"></filter-popover>
                </hc-pop>
            </div>
            <hc-search-bar #searchbar placeholder="Search catalog items" (triggerSearch)="applyTextFilter($event)"
                class="product-catalog-search"></hc-search-bar>
        </div>
        <table hc-table [borders]="false" class="product-catalog-table" [dataSource]="dataSource" hcSort>
            <!-- ID Column -->
            <ng-container hcColumnDef="item">
                <th hc-index-cell *hcHeaderCellDef hc-sort-header id="itemHeader">ID</th>
                <td hc-index-cell *hcCellDef="let element"
                    (click)="openDS(element.item, false)">{{ element.item }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container hcColumnDef="name">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">{{element.name}}</td>
            </ng-container>

            <!-- Category Column -->
            <ng-container hcColumnDef="category">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="categoryHeader">Category</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">{{element.category}}</td>
            </ng-container>

            <!-- Type Column -->
            <ng-container hcColumnDef="type">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="typeHeader">Type</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">
                    <span *ngIf="element.type">{{ element.type }}</span>
                    <span *ngIf="!element.type"> -- </span>
                </td>
            </ng-container>

            <!-- Product Line Column -->
            <ng-container hcColumnDef="productLine">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="productLineHeader"> Product Line</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">
                    <span *ngIf="element.productLine">{{ element.productLine }}</span>
                    <span *ngIf="!element.productLine"> -- </span>
                </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container hcColumnDef="status">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="statusHeader">Status</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">{{ element.status }}</td>
            </ng-container>

            <!-- SLA Column -->
            <ng-container hcColumnDef="sla">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="slaHeader">SLA</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">
                    <span *ngIf="element.sla">{{ element.sla }}</span>
                    <span *ngIf="!element.sla"> -- </span>
                </td>
            </ng-container>

            <!-- Revision Date Column -->
            <ng-container hcColumnDef="revisionDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="revisionDateHeader">Revision Date</th>
                <td hc-cell *hcCellDef="let element" (click)="openDS(element.item, false)">{{
                    element.revisionDate | date: 'shortDate' }}
                </td>
            </ng-container>

            <!-- Icon Actions Column -->
            <ng-container hcColumnDef="actions" justify="center">
                <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
                <td hc-cell *hcCellDef="let element">
                    <div class="hc-table-actions">
                        <span hcMenuIcon class="hc-icons hci-web-link hc-action-ico" hcTooltip="Copy data sheet link"
                            (click)="generateLink(element.item, element.name)"></span>
                        <span hcMenuIcon class="fa fa-download hc-action-ico" hcTooltip="Download data sheet"
                            (click)="openDS(element.item, true)"></span>
                    </div>
                </td>
            </ng-container>

            <tr hc-header-row *hcHeaderRowDef="productsDisplayedColumns"></tr>
            <tr hc-row *hcRowDef="let row; columns: productsDisplayedColumns"></tr>
        </table>
        <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
            <span class="hc-empty-table-block-ico hc-empty-ico"></span>
            <span class="hc-empty-table-block-msg">No products meet your search criteria.</span>
        </div>
        <hc-pagination [length]="productsListLength" [pageSize]="productsPageSize"
            [hidden]="loadError || loading"></hc-pagination>
    </div>
</div>